import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  apiError,
  getRejectreasons,
  rejectreasonsListSuccessful,
  rejectreasonsAddSuccessful,
  isModelVisible,
} from "./rejectreasonsSlice";

// AUTH related methods
import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";
import rejectData from "./rejectData.json"

function* getRejectreason({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    // const response = yield call(getParamsList, "/masters/rejectreasons/", params);
    const RejectData = rejectData
    yield put(rejectreasonsListSuccessful({ RejectData }));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* AddRejectreasons({ payload }) {
  try {
    if (payload.id == 0) {
      const response = yield call(postAdd, "/masters/rejectreasons/", payload);
      if (response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Reject Reason Add Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getRejectreasons({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to added Reject Reason. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(rejectreasonsAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/masters/rejectreasons/" + payload.id,
        payload
      );
      if (response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Reject Reason Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getRejectreasons({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit  Reject Reason. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(rejectreasonsAddSuccessful(null));
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* DeleteRejectreasons({ payload }) {
  var countryID = payload;
  try {
    const response = yield call(postDelete, "/masters/rejectreasons/" + countryID);

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Reject Reason has been deleted!
            </p>
          </div>
        ),
      });
      yield put(getRejectreasons({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Your Reject Reason has been not deleted!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });

    yield put(apiError(error));
  }
}

export function* watchgetRejectreasons() {
  yield takeEvery("rejectreasons/getRejectreasons", getRejectreason);
}
export function* watchRejectreasonsAdd() {
  yield takeEvery("rejectreasons/rejectreasonsAdd", AddRejectreasons);
}

export function* watchRejectreasonsDelete() {
  yield takeEvery("rejectreasons/rejectreasonsDelete", DeleteRejectreasons);
}

function* RejectreasonsSaga() {
  yield all([fork(watchgetRejectreasons), fork(watchRejectreasonsAdd), fork(watchRejectreasonsDelete)]);
}

export default RejectreasonsSaga;
